const CustomDeleted = () =>
  import('@/views/main/wechatMgmt/customDeleted/CustomDeleted.vue')
export default {
  path: '/main/wechatMgmt/customDeleted',
  name: 'CustomDeleted',
  component: CustomDeleted
}
